import z from 'zod';
import { isValidObjectId } from '../../../../helperFunctions';
import {
  optionalMinMaxLength,
  zodBankAccountSchema,
  zodCurrencySchema,
  zodLocationSchema,
  zodPhoneSchema,
  zodStringOptionSchema,
} from '../../../../Validators';

export const editSupplierInfoSchema = z.object({
  _id: z
    .string({
      required_error: 'Supplier ID is required.',
      invalid_type_error: 'Expected string for Supplier ID.',
    })
    .trim()
    .refine(isValidObjectId, {
      message: 'Invalid Supplier ID is required.',
    }),
  supplierName: z
    .string({
      required_error: 'Supplier Name is required',
      invalid_type_error: 'Expected string for Supplier Name.',
    })
    .trim()
    .min(1, { message: 'Supplier Name cannot be empty' }),
  email: z
    .string({
      required_error: 'Email is required',
      invalid_type_error: 'Email must be a string',
    })
    .trim()
    .email({ message: 'Invalid email format' })
    .max(254, { message: 'Email too long' }),
  phone: zodPhoneSchema.optional(),
  description: optionalMinMaxLength(5, undefined, 'Description'),
  currency: zodCurrencySchema,
  invoicePrefix: optionalMinMaxLength(1, 500, 'Invoice Prefix'),
});

export const editSupplierLocationInfoSchema = z.object({
  _id: z
    .string({
      required_error: 'Supplier ID is required.',
      invalid_type_error: 'Expected string for Supplier ID.',
    })
    .trim()
    .min(1, { message: 'Supplier ID cannot be empty.' }),
  locations: z
    .array(zodLocationSchema, {
      required_error: 'Locations are required',
      invalid_type_error: 'Expected array of objects for Locations.',
    })
    .min(1, { message: 'At least one location is required' }),
});

export const editBusinessIDsSchema = z.object({
  companyCodes: z
    .array(zodStringOptionSchema, {
      required_error: 'Business IDs are required.',
      invalid_type_error: 'Expected array of values for Business IDs.',
    })
    .min(1, { message: 'Please Add atleast one business ID.' }),
  _id: z
    .string({
      required_error: 'Supplier ID is required.',
      invalid_type_error: 'Expected string for Supplier ID',
    })
    .trim()
    .min(1, { message: 'Supplier ID cannot be empty.' }),
});

export const editSupplierBankInfoSchema = z.object({
  _id: z
    .string({
      required_error: 'Supplier ID is required.',
      invalid_type_error: 'Expected string for Supplier ID.',
    })
    .trim()
    .min(1, { message: 'Supplier ID cannot be empty.' }),
  bankAccounts: z
    .array(zodBankAccountSchema, {
      required_error: 'Bank Accounts are required',
      invalid_type_error: 'Expected array of objects for Bank Accounts.',
    })
    .min(1, { message: 'At least one bank account is required' }),
});
